import React from "react";
import { SettingsTemplate } from "../../Templates/SettingsTemplate";

export const Settings = () => {
  return <SettingsTemplate />;
};
